import { render, staticRenderFns } from "./ComponentSelector.vue?vue&type=template&id=10dc464d&"
import script from "./ComponentSelector.vue?vue&type=script&lang=ts&"
export * from "./ComponentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComponentSelector.vue"
export default component.exports